import React from "react";
import "./styles.less";
import { CommonConsult } from "../../blocks/common-consult";
import { useTranslation } from "react-i18next";
import { tryNow } from "../../utils";
import Tooltip from "rc-tooltip";

export const PriceBanner = () => {
  const { t } = useTranslation();
  return (
    <div className="price-banner">
      <div className="inner">
        <div className="top">
          <div className="title">
            {t("price.banner.title")}
            <Tooltip
              placement="bottom"
              mouseLeaveDelay={0.001}
              trigger={["hover"]}
              overlay={<div>{t("price.priceList.common-tip")}</div>}
            >
              <span>
                <span className="mauStyle">{t("price.priceList.MAU")}</span>
                <i
                  className="icon authing-icon authing-problem"
                  style={{ color: "#aaaaaa", position: "relative", top: "-28px" }}
                ></i>
              </span>
            </Tooltip>
            {t("price.banner.title-other")}
          </div>
        </div>
        <div className="content-warp">
          <div className="item">
            <div className="item-title">{t("price.banner.section-one.title")}</div>
            <div className="item-button light" onClick={tryNow}>
              {t("price.banner.section-one.button")}
            </div>
            <div className="item-text ">{t("price.banner.section-one.descript")}</div>
          </div>
          <div className="item">
            <div className="item-title">{t("price.banner.section-two.title")}</div>
            <CommonConsult aside={<div className="item-button dark">{t("price.banner.section-two.button")}</div>} />
            <div className="item-text">{t("price.banner.section-two.descript")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
